module.exports = __webpack_public_path__ + "img/11_52.1222a295.png";